const OM = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path
        d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z"
        fill="#fff"
      />
      <path
        d="M13.622 4.644c-1.537 1.05-3.055 1.219-4.78.019.769 1.875 3.73 2.606 5.549 1.181-.244-.375-.487-.75-.769-1.2z"
        fill="#000"
      />
      <path
        d="M12.732 12.043a13.027 13.027 0 00-.272-.2c.056 1.237.675 1.93 1.762 2.1.825.13 1.974-.666 2.283-1.445.31-.779.522-1.806 0-3.17-.481-1.164-1.12-1.91-2.376-2.06-1.294-.15-2.119.563-2.718 1.594-.185.299-.295.64-.402.976-.034.107-.068.213-.105.318a7.878 7.878 0 00-.168.524c-.048.161-.1.339-.169.544-.447-.428-.764-.727-1.081-1.025l-.006-.006c1.106-1.687.993-3.13-.263-4.03-1.368-.994-3.243-.731-4.386.618a45.07 45.07 0 00.712 1.125c.28-.1.544-.208.798-.312.563-.23 1.078-.442 1.62-.494.806-.075 1.5.787 1.444 1.518-.054.88-.71.934-1.341.987l-.084.007c-.066 0-.133.013-.207.027-.051.01-.106.021-.168.03.094.505.188.955.281 1.367 1.444.244 1.725.432 1.837 1.144a1.9 1.9 0 01-1.293 2.062c-.731.244-1.612.319-2.343.15-.613-.13-1.18-.423-1.745-.716-.249-.129-.497-.257-.748-.371-.02 1.743 2.305 2.999 3.861 2.85 1.969-.188 3.337-1.632 3.318-3.506 0-.046 0-.096-.002-.15-.006-.252-.013-.557.096-.619.666-.39.978-1.015 1.293-1.646.154-.309.309-.62.506-.903.244-.356.75-.675 1.181-.75.957-.15 1.744.431 2.081 1.387.319.844.263 1.668-.412 2.325-.637.6-1.612.543-2.512-.057-.087-.054-.168-.115-.272-.193z"
        fill="#000"
      />
      <path
        d="M10.88 3.175c-.218.254-.424.494-.67.795.157.139.298.268.435.392.175.16.343.312.522.47.337-.356.6-.637.881-.956-.3-.338-.544-.6-.918-.994l-.25.293z"
        fill="#F01871"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10-.085C4.43-.085-.085 4.43-.085 10c0 5.57 4.515 10.085 10.085 10.085 5.57 0 10.085-4.515 10.085-10.085C20.085 4.43 15.57-.085 10-.085zM.415 10a9.585 9.585 0 1119.17 0 9.585 9.585 0 01-19.17 0z"
        fill="#F01871"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default OM;
